import Vue from "vue";
import "element-ui/lib/theme-chalk/index.css";
import { Button, Dialog, Menu, MenuItem, Card, Backtop,Carousel,CarouselItem } from "element-ui";
import lang from "element-ui/lib/locale/lang/zh-TW";
import locale from "element-ui/lib/locale";

locale.use(lang);

Vue.use(Button)
Vue.use(Dialog)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Card)
Vue.use(Backtop)
Vue.use(Carousel)
Vue.use(CarouselItem)
